<template>
  <div>
    <FormulateInput
      :name="name"
      :type="type"
      :label="label"
      :validation="validation"
      :placeholder="placeholder"
      @blur-context="inputCallback"
      v-model="value"
      :readonly="readonly"
      @validation="$emit('validation', $event)"
      v-bind="$attrs"
    />
    <!-- <span v-if="placeholder" class="font-size-11 pl-2" style="margin-top: -30px !important;">{{ placeholder }}</span> -->
  </div>
</template>
<script>
export default {
  name: "DateInputComponent",
  props: {
    name: {
      type: String,
      required: true,
    },
    label: {
      type: String,
      required: true,
      default: "Salvar",
    },
    type: {
      type: String,
      required: true,
    },
    placeholder: {
      type: String,
      required: true,
    },
    validation: {
      type: String,
    },
    value: {},

    readonly: {
      type: Boolean,
      required: false,
      default: false,
    }
  },

  methods: {
    inputCallback(value) {
      this.$emit('update', {
        name: this.name,
        model: value
      })
    }
  }
};
</script>